import React from "react";
import "../styles/background.css";

import logo from "../images/logo.png";

import Footer from "./Footer";
import NavBar from "./NavBar";
import { Link } from "react-router-dom";

const Layout = (props) => {


    return(
        <div>
            <Link to="/">
            <img src={logo} height="150" alt=""
            style={{
                position: "fixed",
                top: "0",
                left: "0",
                padding: "10px",
                zIndex:"5000"
            }}/>
            </Link>
            <NavBar/>
            <main>{props.children}</main>
            <Footer/>
        </div>
    )
    }
export default Layout;